import script from "./Locked.vue?vue&type=script&setup=true&lang=js"
export * from "./Locked.vue?vue&type=script&setup=true&lang=js"

import "./Locked.vue?vue&type=style&index=0&id=58bf6be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58bf6be6"]])

export default __exports__